import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { AppService } from './auth/app.service';
import { AppUpdateService } from './core/app-update.service';
import { ContentPath } from './core/content-header/content-path';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less'],
  standalone: false
})
export class AppComponent implements OnInit {

  appManutencao: boolean = false;
  aplicacaoIniciada: boolean = false;
  appInicializacao: number = 0;

  title: string = 'Dashboard';
  subtitle: string = '';
  showContentHeader: boolean = true;
  contentsPath: ContentPath[] = [];
  contentId: string = '';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public app: AppService,
    private appUpdateService: AppUpdateService
  ) {
    // Vincula eventos no router.
    router.events.pipe(
      filter(e => e instanceof NavigationEnd || e instanceof NavigationStart),
      map(e => {
        if (e instanceof NavigationStart) {
          this.showContentHeader = false;
        }

        return e;
      }),
      filter(e => e instanceof NavigationEnd),
      switchMap((event) => {
        let a: ActivatedRoute = this.activatedRoute;

        while (a.firstChild) {
          a = a.firstChild;
        }

        return combineLatest([a.data, a.paramMap]);
      })
    ).subscribe((result) => {
      const routeData = result[0] as any;
      const resolvedHeader = routeData['courseHeader'] as { title?: string; subtitle?: string } | undefined;

      this.contentId = result[1].get('id') ?? '';
      this.title = resolvedHeader?.title ?? routeData['title'] ?? this.title;
      this.subtitle = resolvedHeader?.subtitle ?? routeData['subtitle'] ?? '';
      this.contentsPath = routeData['contentsPath'] ?? [];
      this.showContentHeader = routeData['showContentHeader'] !== false;

      titleService.setTitle(this.title);

      window.scrollTo({ top: 0 });
    });
  }

  ngOnInit(): void {
    // Inicializa o serviço de verificação de atualizações
    this.appUpdateService.checkForUpdates();
  }

}
